import {Component, OnInit, ViewChild, ElementRef} from '@angular/core'
import {Router} from '@angular/router'
import {Form} from '@angular/forms'
import {Subject, Observable} from 'rxjs'
import {FolderService} from '../folder.service'
import {UserService} from '../../user'
import {environment} from '../../../environments/environment'

@Component({
  selector: 'app-folder-edit',
  templateUrl: './folder-edit.component.html',
  styleUrls: ['./folder-edit.component.scss'],
})
export class FolderEditComponent implements OnInit {
  // highlight_save: boolean = true

  env = environment
  owners_ids: Array<string> = []
  viewers_ids: Array<string> = []
  suggestion_viewer: string = ''
  suggestion_owner: string = ''
  subscription: Subject<any>

  owners_field_infos = {
    existing: [],
    success: {
      // email
      // user
      // wildcard
    },
    errors: {
      // incorrect_email
      // user_has_access
      // user_dont_exists
    },
    status: {
      // searching
    },
  }
  viewers_field_infos = {
    existing: [],
    success: {
      // email
      // user
    },
    errors: {
      // incorrect_email
      // user_has_access
      // user_dont_exists
      // unknown
    },
    status: {
      // searching
    },
  }

  debounceSuggestion = new Subject()
  url_input: string
  naming_convention: string
  url_available: boolean = true
  @ViewChild('copyURLInput') copyURLInput

  constructor(
    public folder: FolderService,
    public userService: UserService,
    private router: Router
  ) {
    const subscription = this.debounceSuggestion
      // .map(event => event['target'].value)
      .debounceTime(300)
      .distinctUntilChanged()
      .flatMap(search => Observable.of(search).delay(150))
      .subscribe(d => this.suggest(d))
  }

  ngOnInit() {
    if (this.folder.current) this.subscribe()
    else this.folder.waitForUserInfos(() => this.subscribe())
  }

  subscribe() {
    this.update()
    this.subscription = this.folder.current.subject
      .asObservable()
      .subscribe(() => this.update())
  }

  onSubmit(form) {
    if (!form.valid) return

    let value =
      form.value.level == 'read'
        ? this.suggestion_viewer
        : this.suggestion_owner

    if (value.indexOf('@') > -1) {
      this.folder.addPending(value, form.value.level).then(answer => {
        this.reset(form)
        this.update()
      })
    } else {
      this.userService.getUserWithUsername(value).subscribe(user => {
        if (!this.folder.current.access) this.folder.current.access = {}
        if (!this.folder.current.access[form.value.level])
          this.folder.current.access[form.value.level] = {}
        this.folder.current.access[form.value.level][user['uid']] = {
          level: 1,
          name: user['username'],
        }
        this.folder.updateAccess().then(answer => {
          this.reset(form)
          this.update()
        })
      })
    }

    // console.log(form.value)
  }

  checkURL(event) {
    this.url_input = event.target.value
    if (this.url_input == this.folder.current.customURL)
      this.url_available = true
    else {
      this.folder.checkURL(this.url_input).subscribe(id => {
        this.url_available = id ? false : true
      })
    }
  }

  updateURL() {
    this.folder.updateURL(this.folder.current, this.url_input)
  }

  updateNamingConvention(event) {
    this.folder.current.settings.naming_convention = new FormData(
      event.target
    ).get('naming-convention')
    this.folder.updateSettings()
  }

  copyURL() {
    let input = this.copyURLInput.nativeElement
    input.select()
    document.execCommand('Copy')
    console.log('Notification', 'URL copied to clipboard')
  }

  update() {
    if (!this.folder.current) return

    this.url_input = this.folder.current.customURL || ''

    this.owners_ids = Object.keys(this.folder.current.access.write || {})
    this.viewers_ids = Object.keys(this.folder.current.access.read || {})

    this.owners_field_infos.existing = Object.values(
      this.folder.current.access.write || {}
    ).map(v => v.name)
    this.viewers_field_infos.existing = Object.values(
      this.folder.current.access.read || {}
    ).map(v => v.name)

    this.owners_ids.sort((a, b) =>
      this.folder.current.access.write[a].name.localeCompare(
        this.folder.current.access.write[b].name
      )
    )
    this.viewers_ids.sort((a, b) =>
      this.folder.current.access.read[a].name.localeCompare(
        this.folder.current.access.read[b].name
      )
    )
  }

  updateDescription() {
    this.folder.update(this.folder.current.id, {
      description: this.folder.current.description,
    })
  }

  reset(form) {
    if (form.value.level == 'read') {
      this.suggestion_viewer = ''
    } else {
      this.suggestion_owner = ''
    }
  }

  isEmail(string: string): boolean {
    var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    return re.test(string)
  }

  remove(user: any) {
    let level = user['type'] == 'owner' ? 'write' : 'read'
    this.folder.current.access[level][user['uid']] = null
    this.folder.updateAccess().then(answer => {
      this.update()
    })
  }

  suggest(debounce: any) {
    let input = debounce.event.target['value'].trim()

    let output =
      debounce.group == 'owner'
        ? this.owners_field_infos
        : this.viewers_field_infos
    output.success = {}
    output.errors = {}
    output.status = {}

    let control =
      debounce.form.controls['add-viewer'] ||
      debounce.form.controls['add-owner']
    control.setErrors({incorrect: true})

    if (!input || input == '') return

    try {
      if (input.indexOf('@') > -1) {
        if (!this.isEmail(input)) {
          output.errors['incorrect_email'] = input
        } else {
          if (input.split('@')[0] == '*')
            output.success['wildcard'] = input.substring(1)
          else output.success['email'] = input
          control.setErrors(null)
        }
      } else {
        if (!/^[0-9A-Za-z\s\-]+$/.test(input)) {
          output.errors['unknown'] = input
        } else {
          input = input.toLowerCase()
          if (output.existing.indexOf(input) > -1) {
            output.errors['user_has_access'] = input
          } else {
            output.status['searching'] = input
            let username_sub = this.userService
              .checkUsername(input)
              .subscribe(user => {
                username_sub.unsubscribe()
                output.status['searching'] = false
                if (user) {
                  output.success['user'] = input
                  control.setErrors(null)
                } else {
                  output.errors['user_dont_exists'] = input
                }
              })
          }
        }
      }
    } catch (e) {
      output.errors['unknown'] = ''
    }
  }

  ngOnDestroy() {
    if (this.subscription) this.subscription.unsubscribe()
  }
}



// WEBPACK FOOTER //
// /Users/axel/Sites/Bannerboy/Internal/attaboy-angular/src/app/folder/folder-edit/folder-edit.component.ts